import { Lightbulb } from 'lucide-react';
import useTenantVertical from '@/hooks/useTenantVertical';
import verticalExamples from '@/help/verticalExamples';

export default function VerticalExampleBox({ module }) {
  const vertical = useTenantVertical();
  const examples = verticalExamples[vertical] || verticalExamples.generic;
  const text = examples?.[module];
  if (!text) return null;
  return (
    <div className="bg-[#FFFBEB] border border-[#FDE68A] rounded-lg px-3 py-2 flex items-start gap-2" data-testid={`help-vertical-${module}`}>
      <Lightbulb className="w-3.5 h-3.5 text-[#D97706] mt-0.5 flex-shrink-0" />
      <div className="text-xs text-[#92400E] leading-relaxed">
        <span className="font-medium">Ejemplo ({examples.label}): </span>{text}
      </div>
    </div>
  );
}
